module.exports = __webpack_public_path__ + "media/svg/symbols-d73956a7.svg";